import { Checkbox } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./proposal_form.css";
import AppTextField from "../../../component/app_text_field/app_text_field";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import UtilBloc from "../../../../bloc/util_bloc";
import AppModal from "../../../component/app_modal/app_modal";
import FormsBloc from "../../../../bloc/forms_bloc";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import { isContainNumberOnly, nameValidation, numberValidation } from "../../../component/app_validation";

class CreditCardPaymentDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.containerRef = React.createRef();
        this.contentRef = React.createRef();
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            creditCardData: {
                cardHolderName: null,
                creditCardNo: null,
                creditCardType: null,
                creditCardExpiryDate: null,
                issueBankCode: null,
                isAuthorisedChecked: false,
                isTermsAndConditionChecked: false,
            },
            bankList: null,
            termsConditionOpen: false,
            termsConditionViewed: false,
            errorMessage: 'Fill in the required field.',
            isTermsConditionScrollToEnd: false,
            checkScrollable: false
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    setPropValue = () => {
        let valueobj = this.state.creditCardData;
        this.props.onChange(valueobj);
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
        this.getFormData();
    }

    initiateData() {
        let formData = this.props.value;
        let stateData = this.state.creditCardData;
        formData && Object.keys(formData).map(function (key) {
            stateData[key] = formData[key];
        })
        this.setState({ creditCardData: stateData }, () => {
            if (!UtilBloc.isNullOrEmpty(this.state.creditCardData.accHolderName) && !UtilBloc.isNullOrEmpty(this.state.creditCardData.creditCardNo) && !UtilBloc.isNullOrEmpty(this.state.creditCardData.issueBankCode)) {
                this.handleValuehange('isTermsAndConditionChecked', true);
            }
        })
    }
    async getFormData() {
        this.setState({ loading: true });
        let bankList = await FormsBloc.getBankList();
        this.setState({
            bankList: bankList.data,
            loading: false
        });
    }

    getFormFields() {
        return this.props.fields;
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop >= e.target.clientHeight;
        if (bottom) {
            this.handleValuehange('isTermsAndConditionChecked', true);
            this.setState({ termsConditionViewed: true });
        }
    }

    onValidateForm = () => {
        const { creditCardData } = this.state;
        let validated = true;
        console.log('creditCardData', creditCardData);
        Object.keys(creditCardData).map(function (key) {
            if (key == 'creditCardNo') {
                let cleanCreditCardNo = creditCardData[key]?.replace(/\s/g, '');
                validated = validated && ((UtilBloc.isContainNumberOnly(cleanCreditCardNo) && cleanCreditCardNo?.length >= 16) || false);
            } else if (key == 'accHolderName') {
                validated = validated && (!UtilBloc.nameValidation(creditCardData[key]) || false);
            }
            else {
                validated = validated && (!UtilBloc.isNullOrEmpty(creditCardData[key]) || false);
            }
            console.log('key', key, 'validated', validated);
        });
        this.setPropValidation(validated);
        this.setPropValue();
        console.log('validated', validated);
        return validated;
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }

    handleValuehange = (field, val) => {
        let data = this.state.creditCardData;
        if (field === 'creditCardExpiryDate') {
            let date = val.replace(/[^0-9]/g, '');
            if (date.length > 2 && date[2] !== '/') {
                date = date.slice(0, 2) + '/' + date.slice(2);
                val = date;
            }
        }
        console.log("field", field, "val", val);
        data[field] = val
        this.setState({ creditCardData: data });
        this.onValidateForm();
    }

    handleNameChange(val) {
        this.setState({ name: val })
    }
    handlecreditCardNoChange(val) {
        this.setState({ creditCardNo: val })
    }
    handleBankNameChange(val) {
        this.setState({ issueBankCode: val })
    }

    handleTermsAndCondition(val) {
        if (this.state.termsConditionViewed == true) {
            this.handleValuehange('isTermsAndConditionChecked', val);
        } else {
            this.handleValuehange('isTermsAndConditionChecked', null);
        }
    }

    handleAuthorised(val) {
        this.handleValuehange('isAuthorisedChecked', val);
    }

    async handleFormSubmit() {

    }


    creditCardType() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.creditCardType}
                value={this.state.creditCardData.creditCardType}
                placeholder={'Select credit card type...'}
                options={Config.proposal.optionItem.cardType}
                onChange={(e) => { this.handleValuehange(this.getFormFields().creditCardType, e) }}
            />
        )
    }

    issueBankCode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.bank}
                value={this.state.creditCardData.issueBankCode}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                placeholder={'Select bank name...'}
                options={this.state.bankList}
                onChange={(e) => { this.handleValuehange(this.getFormFields().issueBankCode, e) }}
            />
        )
    }

    creditCardNo() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.creditCardNo}
                type={'credit_card'}
                placeholder={'•••• •••• •••• ••••'}
                value={this.state.creditCardData.creditCardNo}
                maxLength={19}
                // onValidate={(value) => { return (!UtilBloc.isContainNumberOnly(value) || value?.length < 7) }}
                errorMessage={numberValidation(this.state.creditCardData.creditCardNo) || 'Please enter a valid credit card number.'}
                onChange={(e) => { this.handleValuehange(this.getFormFields().creditCardNo, e) }}
            />
        )
    }

    creditCardcreditCardExpiryDate() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.creditCardExpiryDate}
                type={'text'}
                placeholder={'Enter expiry date...'}
                value={this.state.creditCardData.creditCardExpiryDate}
                maxLength={5}
                // onValidate={(value) => { return (!UtilBloc.isContainNumberOnly(value) || value?.length < 7) }}
                // errorMessage={numberValidation(this.state.creditCardData.creditCardExpiryDate) || 'Please enter a valid expiry date.'}
                onChange={(e) => { this.handleValuehange(this.getFormFields().creditCardExpiryDate, e) }}
            />
        )
    }

    name() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.cardHolderName}
                type={'text'}
                placeholder={'Enter account holder’s name...'}
                value={this.state.creditCardData.cardHolderName}
                onValidate={(value) => { return UtilBloc.nameValidation(value) }}
                errorMessage={nameValidation(this.state.creditCardData.cardHolderName)}
                onChange={(e) => this.handleValuehange(this.getFormFields().cardHolderName, e)}
            />
        )
    }

    termAndCondition() {
        return (
            <div className="mt-3 w-100">
                <div className="w-100">
                    <Checkbox onChange={(e) => this.handleAuthorised(e.target.checked)} checked={this.state.creditCardData.isAuthorisedChecked}>
                        I hereby authorise the bank appointed by <span style={{ fontWeight: 'bold' }}>FWD Takaful</span> to debit my credit card account for the purpose of payment of the contribution for this application.
                    </Checkbox>
                </div>
                <div>
                    <Checkbox onChange={(e) => this.handleTermsAndCondition(e.target.checked)} checked={this.state.creditCardData.isTermsAndConditionChecked}>
                        I have read and hereby accept the
                        <span
                            style={{ color: '#EE7623', cursor: 'pointer' }}
                            onClick={(e) => { e.stopPropagation(); this.setState({ termsConditionOpen: true }) }}>
                            {' '}Terms and Conditions
                        </span> for Credit Debit Card Authorisation.
                    </Checkbox>
                </div>
            </div>
        )
    }

    renderTermsAndConditionContent = () => {
        return (
            <>
                <div className="mt-4 px-3" style={{ height: '35vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} ref={this.containerRef}>
                    <div ref={this.contentRef} style={{ height: '45vh' }}>
                        <div className="quotation_privacy_policy_container d-flex">
                            <span className="quotation_privacy_policy_title">Credit Debit Card Authorisation</span>
                        </div>
                        <div className='p-3'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
                        </div>
                    </div>
                </div>
            </>
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>
                {this.state.loading && this.loadingContent()}
                <div className="w-100" >
                    <div className="mt-3">
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.name()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.creditCardNo()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.creditCardType()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.creditCardcreditCardExpiryDate()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.issueBankCode()}
                            </div>
                        </div>
                        {this.termAndCondition()}
                    </div>
                    <AppModal
                        open={this.state.termsConditionOpen}
                        handleModalClose={() => this.setState({ termsConditionOpen: false })}
                        width={'70%'}
                        title={'Credit Card Terms and Conditions.'}
                        subtitle={'Last Updated on 30 Jan 2024'}
                    >
                        {this.renderTermsAndConditionContent()}
                    </AppModal>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(CreditCardPaymentDetails));
